<template>
  <div @click="toggleOffer">
    <div v-if="!showOffer" class="offer-toggle">

      <div class="offer-toggle__left">
        <h3 class="s-heading s-heading--3">
          <span class="s-heading__text">{{ offer.offer_banner_headline }}</span>
        </h3>
        <p class="s-copy">{{ offer.offer_banner_copy }}</p>
        <div class="s-buttons">
          <div class="s-button s-button--inverted">
          <span class="s-button__text">{{ offer.offer_banner_button }}</span>
          </div>
        </div>
      </div>
      <div class="offer-toggle__right" v-if="templateUri">
        <img :src="templateUri + '/assets/src/img/K2_Aktion.png'" alt="">
      </div>
    </div>
    <div v-if="showOffer" class="offer-toggle__back">
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <use href="#s-icon-arrow-left-small-16" xlink:href="#s-icon-arrow-left-small-16"></use>
      </svg>
      <span class="s-copy s-copy--s">{{ offer.offer_banner_back }}</span>
    </div>
  </div>

</template>

<script>
export default {
  computed: {
    showOffer(){
      return this.$store.state.showOffer && this.$store.state.wpdata[wpGlobalData.language].offer.activate_offer;
    },
    templateUri(){
      return wpGlobalData.template_directory_uri;
    },
    offer() {
      return this.$store.state.wpdata[wpGlobalData.language].offer.offer_details[0];
    }
  },
  methods: {
    toggleOffer() {
      this.$store.commit('toggleOffer');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OfferToggle.vue